import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
      path: '/main',
      component: () => import('@/views/main.vue'),
      // children: [
      //   {
      //     path: '/introduction',
      //     component: () => import('@/components/introduction.vue')
      //   },
      //   {
      //     path: '/getStart',
      //     component: () => import('@/components/getStart.vue')
      //   },
      //   {
      //     path: '/platForm',
      //     component: () => import('@/components/FaxchainPlatformOverview.vue')
      //   },
      // ]
      }
    ]
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({y:0}),
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
